import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as accountActions from '../../../../../actions/account/account';
import PreferencesForm from './PreferencesForm';

// todo if no prefs - error

// TODO frequency will be made up of a person's initial values OR defaulted to as posted!!!!!!

class PreferenceSettingsMainPage extends Component {

    componentDidMount() {

        const personId = localStorage.getItem('person_id');
        const {setPreferences, preferences} = this.props;

        if (!preferences) setPreferences(personId);
    }
    handleUpdatePreferences(personId, preferences) {
        this.props.updatePreferences(personId, preferences);
    }

    render() {

        const personId = localStorage.getItem('person_id');

        const { preferences } = this.props;

        if (!preferences) return <h4 className="h4">No preferences...</h4>;

        // else if (preferences.methods.length === 0 || preferences.subscriptions.length === 0) return <h5 className="h5">Oops, you have no preferences.</h5>;

        // else {
            return (
                <div className="row">
                    <div className="col-xs-12">
                        <h3 className="h3 title--uppercase">At In Touch Networks, your aspirations, goals and&nbsp;needs are our priority.</h3>
                        <p className="p-tag">To make sure we can tailor our communications to best suit these factors, it is important you let us know what you're looking for.</p>
                        <p className="p-tag">One of the next steps to the success of your career is therefore filling our preferences form below. This ensures we know exactly what you are looking for and can optimise and tailor our services and emails to you, keeping you up to date with what really matters to you, and ensuring you never miss out.</p>

                        <PreferencesForm
                            handleFormSubmit={ (preferences) => {
                                this.handleUpdatePreferences(personId, preferences)
                            } }
                        />
                    </div>

                </div>
            )
        // }
    }
}

const mapStateToProps = (state) => {
    return {
        preferences: state.account.preferences,
    }
};


const mapDispatchToProps = (dispatch) => {
    return {
        setPreferences: (personId) => dispatch(accountActions.setPreferences(personId)),
        updatePreferences: (personId, preferences) => dispatch(accountActions.updatePreferences(personId, preferences)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PreferenceSettingsMainPage);


// WEBPACK FOOTER //
// src/client/components/site/features/account/preferences/PreferenceSettingsMainPage.js